import { LoadingOutlined } from '@ant-design/icons'
import { Observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import { useHistory , useLocation } from 'react-router-dom'
import { PrimaryButton, SecondaryButton } from '../../../../../common/components/buttons/NewButtons.styles'
import { navigateToUrl } from '../../../../../common/utils/navigation.utils'
import { useStore } from '../../../../app/data/root.store'
import { VipDocuSignIframeWrapper, VipSyncStepFooter, VipSyncStepWrapper } from '../../AddItem.styles'
// import { VipSyncConsent } from './steps-vip-sync/VipSyncConsent'
import { ROUTES } from '../../../../../common/constants/routes.const'
import { useAnalytics } from '../../../../app/data/AnalyticsProvider'
import { VipSyncManualConsent } from './steps-vip-sync/VipManualConsent'
import { VipSyncIntro } from './steps-vip-sync/VipSyncIntro'
// import { VipSyncDocuSignSigningStep } from './steps-vip-sync/VipSyncDocuSignSigningStep'
import { getData } from '../../../../../common/utils/network.utils'
import { errorNotification } from '../../../../layout/components/Notifications/notifications'
import { VipPendingModal } from './steps-vip-sync/VipPendingModal'

const vipSyncSteps = [VipSyncIntro, VipSyncManualConsent]
const vipSyncActionButtonTextByIndex = {
  '0_manual': 'Login & Continue',
  '0_docusign': 'Review & Sign',
  1: 'Confirm & Continue',
  2: 'Done',
}
const vipMixpanelByIndex = {
  '0_manual': {
    cta_text: 'Login & Continue',
    destination: 'Service Agreement',
  },
  '0_docusign': {
    cta_text: 'Review & Sign',
    destination: 'Service Agreement',
  },
  1: {
    cta_text: 'Confirm & Continue',
    destination: 'Success Screen',
  },
  2: {
    cta_text: 'Done',
    destination: 'Synced Account Page',
  },
}

export const VipSyncFlow = ({ isActivationFlow, item, stepIndex }) => {
  const { userStore, createItemStore, uiStore , itemStore } = useStore();
  const history = useHistory();
  const location = useLocation();
  const CurrentVipSyncStep = vipSyncSteps[stepIndex];
  const [isConsentApproved, setIsConsentApproved] = useState(false);
  const [isVipPendingModalOpen, setIsVipPendingModalOpen] = useState(false);
  const { trackEvent } = useAnalytics();
  const [documentToSignUrl, setDocumentToSignUrl] = useState(null);
  const [isDocumentToSignUrlLoading, setIsDocumentToSignUrlLoading] = useState(false);

  const handleBackClick = () => {
    if (stepIndex === 0) {
      createItemStore.setInstitutionStep(createItemStore.syncMode);
    }
    if ([1,2].includes(stepIndex)) {
      createItemStore.setVipSyncStepIndex(0);
    } else {
      if (item.vipAccessRequirement === 'manual') {
        createItemStore.setVipSyncStepIndex(1);
      } else {
        createItemStore.setVipSyncStepIndex(2);
      }
    }
  }

  const handleNextClick = async () => {
    const isDisabled = stepIndex === 1 && !isConsentApproved;
    if (isDisabled) return;
    trackEvent('CTA Clicked', {
      cta_text: vipMixpanelByIndex[stepIndex + ( stepIndex === 0 ? `_${item.vipAccessRequirement === 'manual' ? 'manual' : 'docusign'}` : ``)].cta_text,
      destination: vipMixpanelByIndex[stepIndex + ( stepIndex === 0 ? `_${item.vipAccessRequirement === 'manual' ? 'manual' : 'docusign'}` : ``)].destination,
      location: 'VIP Sync Service',
      type: 'Button',
      institution: item.name,
    })

    if (stepIndex === 1) {
      
      createItemStore.createVipAsset(()=>{
        setIsVipPendingModalOpen(true);
        itemStore.setItemUpdated(true);
        // connectedInstitutionsStore.setShowVipPendingModal(1);
      });
    }
    // if (stepIndex === 2) {
    //   createItemStore.setShowModal(false);
    //   if (window.location.pathname.includes(ROUTES.accounts.url)) {
    //     connectedInstitutionsStore.fetchData();
    //   } else {
    //     navigateToUrl(history, ROUTES.accounts.url);
    //   }
    // } 
    else {
      if (item.vipAccessRequirement === 'manual') {
        createItemStore.setVipSyncStepIndex(1);
      } else {
        setIsDocumentToSignUrlLoading(true);
        try {
          const docUrlResponse = await getData(`docu-sign/create-envelope/${item.id}`); //.then(response => response.data.url);
          createItemStore.setIsShowDocuSignIframe(true);
          // console.log(docUrlResponse.data.docUrl);
          setDocumentToSignUrl(docUrlResponse.data.docUrl);
        } catch (error) {
          errorNotification('Something went wrong, please contact support');
          //console.error('Error fetching document to sign URL:', error);
        } finally {
          setIsDocumentToSignUrlLoading(false);
        }
      }
    }
  }

  const handlePreferManuallyClick = () => {
    createItemStore.setCategoryStep({ name: item.name });
    trackEvent('CTA Clicked', {
      cta_text: 'I prefer to add this item manually',
      location: 'VIP Sync Service',
      type: 'Button',
      destination: 'add manual item',
      institution: item.name,
    })
  }

  const handleContactSupportClick = () => {
    const message = `I can't give access to Vyzer's Syncing Service to ${item.name} platform.`
    window.Intercom && window.Intercom('showNewMessage', message);
  }

  const handleVipPendingModalDone = () => {
    setIsVipPendingModalOpen(false);
    createItemStore.setShowModal(false);
    if (location.pathname === ROUTES.accounts.url) {
      window.location.reload();
    } else {
      navigateToUrl(history, ROUTES.accounts.url);
    }
  }

  useEffect(() => {
    return () => {
      createItemStore.setIsFromVipVipSyncingTab(false);
    }
  }, [createItemStore])

  
  // Add event listener for DocuSign completion
  useEffect(() => {
    const handleDocuSignMessage = (event) => {
      if (event.data && event.data.type === 'DOCUSIGN_COMPLETE') {
        // Hide the DocuSign iframe
        createItemStore.setIsShowDocuSignIframe(false);
        
        // Handle different status cases
        if (event.data.status === 'success') {
          createItemStore.createVipAsset(()=>{
            setIsVipPendingModalOpen(true);
            itemStore.setItemUpdated(true);
            // connectedInstitutionsStore.setShowVipPendingModal(1);
          });
          // successNotification('Document signed successfully');
          // Move to the next step or perform any additional actions needed
          // if (item.vipAccessRequirement !== 'manual') {
          //   createItemStore.setVipSyncStepIndex(2);
          // }
        } else if (event.data.status === 'cancelled') {
          // Handle cancelled signing
          errorNotification('Document signing was cancelled');
        } else if (event.data.status === 'error') {
          // Handle error in signing
          errorNotification('An error occurred during document signing');
        }
      }
    };

    window.addEventListener('message', handleDocuSignMessage);

    return () => {
      window.removeEventListener('message', handleDocuSignMessage);
    };
  }, [createItemStore, item, itemStore]);

  return (<Observer>{() => (
    <VipSyncStepWrapper>
      <CurrentVipSyncStep item={item} isConsentApproved={isConsentApproved} setIsConsentApproved={setIsConsentApproved} userStore={userStore} />
      {createItemStore.isShowDocuSignIframe && <VipDocuSignIframeWrapper><iframe src={documentToSignUrl} width="100%" height="100%" title="Vyzer Service Agreement"></iframe></VipDocuSignIframeWrapper>}
      {!isActivationFlow ? <VipSyncStepFooter>
        { [1,2].includes(stepIndex) || (stepIndex !== 3 && !createItemStore.isFromVipVipSyncingTab) ? <SecondaryButton onClick={handleBackClick} style={{ padding: '10px 20px', maxHeight: '38px' }}>Back</SecondaryButton> : null}
        { stepIndex === 1 && <SecondaryButton onClick={handleContactSupportClick} style={{ padding: '10px 20px', maxHeight: '38px' }}>Contact support</SecondaryButton> }
        {stepIndex === 0 && !createItemStore.isFromVipVipSyncingTab ? <SecondaryButton onClick={handlePreferManuallyClick} style={{ padding: '10px 20px', maxHeight: '38px' }}>I prefer to add this item manually</SecondaryButton> : null}
        <PrimaryButton disabled={stepIndex === 1 && !isConsentApproved && !createItemStore.isSavingItem} onClick={handleNextClick} style={{ maxHeight: '38px', marginLeft: 'auto', ...(uiStore.isDesktopView ? {} : {width:'100%'} ) }}>{createItemStore.isSavingItem || isDocumentToSignUrlLoading ? <LoadingOutlined /> : vipSyncActionButtonTextByIndex[stepIndex + ( stepIndex === 0 ? `_${item.vipAccessRequirement === 'manual' ? 'manual' : 'docusign'}` : ``) ]}</PrimaryButton>
      </VipSyncStepFooter> : null}
      {isVipPendingModalOpen && <VipPendingModal item={item} onDone={handleVipPendingModalDone} />}
    </VipSyncStepWrapper>
  )}</Observer>)
}
